import { baseApiAuthenticated } from '@/api/v2/index';
import { buildSearchParams, urlBuilder } from '@/api/utils';
import { convertMailToFrontendType, Mail } from '@/models/mail';
import { BackendType } from '@/models/general';

const baseUrl = urlBuilder('ses', 'mails');

export type GetMailSearchParams = {
    userId?: string;
    orderId?: string;
    to?: string;
};

export type GetMailResponse = {
    mails: Mail<BackendType>[];
};

export const mailsApi = baseApiAuthenticated.injectEndpoints({
    endpoints: (builder) => ({
        getMails: builder.query<Mail[], GetMailSearchParams | null>({
            query: (searchParams: GetMailSearchParams) =>
                `${baseUrl}${buildSearchParams(searchParams)}`,

            transformResponse(response: GetMailResponse) {
                return response.mails.map(convertMailToFrontendType);
            },
        }),
    }),
});

export const { useLazyGetMailsQuery, useGetMailsQuery } = mailsApi;
